'use client'

import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import { cx } from 'classix'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { Channel } from 'types/masterData'
import { usePricesStore } from '../../../context/PricesProvider'
import type { Price } from '../../../store/pricesStore/pricesStore'
import styles from '../ExtraInfo.module.css'
import { PricesHistory } from './PricesHistory'
import { Title } from './Title'

export type BodyContentProps = {
	readonly pricesHistory: Price[]
	readonly shouldShowDiscount: boolean
	readonly title?: string | null
}

export function BodyContent({
	pricesHistory,
	shouldShowDiscount,
	title,
}: BodyContentProps) {
	const { channel } = usePricesStore()
	const { t } = useLabels()

	const priceDescriptionLabel =
		channel === Channel.Shop
			? 'productCard.discountDescription.text'
			: 'productCard.discountDescription.outlet.text'

	return (
		<div className={styles.bodyContent}>
			{title && <Title title={title} />}
			<PricesHistory pricesHistory={pricesHistory} />

			{shouldShowDiscount && (
				<p className={cx(textBodyS.className, styles.pricesDescription)}>
					{t(priceDescriptionLabel)}
				</p>
			)}
		</div>
	)
}
